import { useSelectionStore } from "../stores/selectionStore";

let pendingAutoParent = null;
let unsubscribeSelection = null;

const normalizeGeomUuid = (selectionKey) => {
  if (!selectionKey) return null;
  const str = String(selectionKey);
  const sepIdx = str.indexOf(":");
  return sepIdx >= 0 ? str.slice(sepIdx + 1) : str;
};

const selectedTargetMatches = (selectionState, pending) => {
  if (!pending) return false;
  switch (pending.itemType) {
    case "joint":
      return selectionState.selectedJoint === pending.itemUuid;
    case "site":
      return selectionState.selectedSite === pending.itemUuid;
    case "geom":
      return normalizeGeomUuid(selectionState.selectedGeom) === pending.itemUuid;
    default:
      return false;
  }
};

const ensureSelectionSubscription = () => {
  if (unsubscribeSelection) return;
  unsubscribeSelection = useSelectionStore.subscribe((selectionState) => {
    if (!pendingAutoParent) return;
    if (!selectedTargetMatches(selectionState, pendingAutoParent)) {
      pendingAutoParent = null;
    }
  });
};

export const rememberAutoParentForSelectedItem = ({ itemType, itemUuid, parentBodyUuid }) => {
  if (!itemType || !itemUuid || !parentBodyUuid) return;
  ensureSelectionSubscription();
  pendingAutoParent = {
    itemType,
    itemUuid: String(itemUuid),
    parentBodyUuid: String(parentBodyUuid),
  };
};

export const getPendingAutoParentForSelection = (itemType, itemUuid) => {
  if (
    !pendingAutoParent ||
    pendingAutoParent.itemType !== itemType ||
    pendingAutoParent.itemUuid !== String(itemUuid || "")
  ) {
    return null;
  }
  return pendingAutoParent.parentBodyUuid;
};

export const clearPendingAutoParentForSelection = (itemType, itemUuid) => {
  if (
    pendingAutoParent &&
    pendingAutoParent.itemType === itemType &&
    pendingAutoParent.itemUuid === String(itemUuid || "")
  ) {
    pendingAutoParent = null;
  }
};
